import request from '@/utils/request'

// 开票信息列表
export const getInvoiceProfileList = data => {
  return request({
    url: '/api/business/invoiceProfile/getList',
    method: 'POST',
    data
  })
}

// 开票信息详情
export const getInvoiceProfileInfo = id => {
  return request({
    url: `/api/business/invoiceProfile/getInfo/${id}`,
    method: 'GET'
  })
}

// 新增/编辑开票信息
export const modifyInvoiceProfile = data => {
  return request({
    url: '/api/business/invoiceProfile/modifyData',
    method: 'POST',
    data
  })
}

// 删除开票信息
export const removeInvoiceProfile = id => {
  return request({
    url: `/api/business/invoiceProfile/remove/${id}`,
    method: 'POST'
  })
}

// 设为默认
export const setDefaultInvoiceProfile = id => {
  return request({
    url: `/api/business/invoiceProfile/setDefault/${id}`,
    method: 'POST'
  })
}
